/**
 * Analisi del rischio
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 3.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {SuccessfulResponseIterableEvento} from '../model/successfulResponseIterableEvento';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EventoControllerService {

	protected basePath = 'http://localhost:5003';
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains 'multipart/form-data', false: otherwise
	 */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
	 * Effettua il get della lista dei Applicazione in anagrafica
	 *
	 * @param page numero di pagina
	 * @param size quantità degli elementi da richiedere
	 * @param id Imposta filtro su campo id
	 * @param codiceAnalisi Imposta filtro su campo codiceAnalisi
	 * @param tipoEvento Imposta filtro su campo tipo
	 * @param livelloEvento Imposta filtro su campo livello
	 * @param link Imposta filtro su campo link
	 * @param messaggio Imposta filtro su campo messaggio
	 * @param fromData Imposta filtro per gli eventi a partire dalla data fromData
	 * @param toData Imposta filtro per gli eventi fino alla data toData
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public getAllApplicazione1(page?: number, size?: number, id?: number, codiceAnalisi?: string, tipoEvento?: string, livelloEvento?: string, link?: string, messaggio?: string, fromData?: Date, toData?: Date, observe?: 'body', reportProgress?: boolean): Observable<SuccessfulResponseIterableEvento>;
	public getAllApplicazione1(page?: number, size?: number, id?: number, codiceAnalisi?: string, tipoEvento?: string, livelloEvento?: string, link?: string, messaggio?: string, fromData?: Date, toData?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SuccessfulResponseIterableEvento>>;
	public getAllApplicazione1(page?: number, size?: number, id?: number, codiceAnalisi?: string, tipoEvento?: string, livelloEvento?: string, link?: string, messaggio?: string, fromData?: Date, toData?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SuccessfulResponseIterableEvento>>;
	public getAllApplicazione1(page?: number, size?: number, id?: number, codiceAnalisi?: string, tipoEvento?: string, livelloEvento?: string, link?: string, messaggio?: string, fromData?: Date, toData?: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (page !== undefined && page !== null) {
			queryParameters = queryParameters.set('page', <any>page);
		}
		if (size !== undefined && size !== null) {
			queryParameters = queryParameters.set('size', <any>size);
		}
		if (id !== undefined && id !== null) {
			queryParameters = queryParameters.set('id', <any>id);
		}
		if (codiceAnalisi !== undefined && codiceAnalisi !== null) {
			queryParameters = queryParameters.set('codiceAnalisi', <any>codiceAnalisi);
		}
		if (tipoEvento !== undefined && tipoEvento !== null) {
			queryParameters = queryParameters.set('tipoEvento', <any>tipoEvento);
		}
		if (livelloEvento !== undefined && livelloEvento !== null) {
			queryParameters = queryParameters.set('livelloEvento', <any>livelloEvento);
		}
		if (link !== undefined && link !== null) {
			queryParameters = queryParameters.set('link', <any>link);
		}
		if (messaggio !== undefined && messaggio !== null) {
			queryParameters = queryParameters.set('messaggio', <any>messaggio);
		}
		if (fromData !== undefined && fromData !== null) {
			queryParameters = queryParameters.set('fromData', <any>fromData.toISOString());
		}
		if (toData !== undefined && toData !== null) {
			queryParameters = queryParameters.set('toData', <any>toData.toISOString());
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<SuccessfulResponseIterableEvento>('get', `${this.basePath}/api/v1/evento`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
